// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__jidFo","slider":"styles_slider__vLYzY"};